import { render, staticRenderFns } from "./residentNavigator.vue?vue&type=template&id=76a9a1dc&scoped=true"
import script from "./residentNavigator.vue?vue&type=script&lang=ts"
export * from "./residentNavigator.vue?vue&type=script&lang=ts"
import style0 from "./residentNavigator.vue?vue&type=style&index=0&id=76a9a1dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a9a1dc",
  null
  
)

export default component.exports